export default __webpack_public_path__ + "static/B0118-51f384a2b08a5aea7b9b60ccaadbc2dd.png";